import { NotificationsActionsTypes } from './actions';

const initialState = {
  preview: { count: null, loading: false, error: null, requestId: 0 },
  send: { loading: false, error: null, result: null },
  history: { items: [], loading: false, error: null, loaded: false },
};

// Newest first, de-duplicated by id. A confirmed server row supersedes any
// optimistic local row that shares its id.
const mergeById = (primary, secondary) => {
  const seen = new Set(primary.map((b) => b.id));
  return [...primary, ...secondary.filter((b) => !seen.has(b.id))].sort(
    (a, b) => new Date(b.sentAt) - new Date(a.sentAt),
  );
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NotificationsActionsTypes.PREVIEW_BROADCAST_STARTED:
      return { ...state, preview: { count: null, loading: true, error: null, requestId: action.payload.requestId } };
    case NotificationsActionsTypes.PREVIEW_BROADCAST_SUCCESS:
      // Drop responses that belong to a superseded request.
      if (action.payload.requestId !== state.preview.requestId) return state;
      return { ...state, preview: { ...state.preview, count: action.payload.count, loading: false, error: null } };
    case NotificationsActionsTypes.PREVIEW_BROADCAST_FAILURE:
      if (action.payload.requestId !== state.preview.requestId) return state;
      return { ...state, preview: { ...state.preview, count: null, loading: false, error: action.payload.error } };

    case NotificationsActionsTypes.SEND_BROADCAST_STARTED:
      return { ...state, send: { loading: true, error: null, result: null } };
    case NotificationsActionsTypes.SEND_BROADCAST_SUCCESS:
      return { ...state, send: { loading: false, error: null, result: action.payload } };
    case NotificationsActionsTypes.SEND_BROADCAST_FAILURE:
      return { ...state, send: { loading: false, error: action.payload, result: null } };

    case NotificationsActionsTypes.HISTORY_STARTED:
      return { ...state, history: { ...state.history, loading: true, error: null } };
    case NotificationsActionsTypes.HISTORY_SUCCESS:
      // Server is the source of truth: replace with its rows (dropping any
      // optimistic local ones, which the server list now includes).
      return {
        ...state,
        history: { items: action.payload.broadcasts, loading: false, error: null, loaded: true },
      };
    case NotificationsActionsTypes.HISTORY_FAILURE:
      return { ...state, history: { ...state.history, loading: false, error: action.payload } };

    case NotificationsActionsTypes.RECORD_LOCAL_BROADCAST:
      // Optimistic prepend so a send shows immediately, before the refetch.
      return {
        ...state,
        history: { ...state.history, items: mergeById([action.payload], state.history.items) },
      };

    case NotificationsActionsTypes.HYDRATE_HISTORY_CACHE:
      // Only paint from cache before the first live load, never over fresh data.
      if (state.history.loaded) return state;
      return { ...state, history: { ...state.history, items: action.payload.broadcasts } };

    // Keep the loaded log across the compose form's reset (unmount cleanup);
    // only the preview/send scratch state is transient.
    case NotificationsActionsTypes.RESET_BROADCAST:
      return { ...initialState, history: state.history };

    default:
      return state;
  }
};
